/* VendorEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("../CommonEditor");
const getDefaultCreateValue = require("./mapDataUtil");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class VendorEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
    }

    _init() {
        const dropDownData = _.get(this._itemData, "vendorOptions", []);
        this.input.setOptions(dropDownData);
        super._init();
    }

    applyValue(item, state) {
        super.applyValue(item, state);
        let _val;
        if (item.vendor) {
            if (item.netBoxPlatform) {
                _val = this.getPlatform(item);
                if (_val) {
                    item.pfValue = _val;
                }
                item.netBoxName = getDefaultCreateValue(item.vendor, _val, item.vendorOptions);
            } else if (item.netBoxDeviceType) {
                _val = this.getSku(item);
                if (_val) {
                    item.skuValue = _val;
                }
                item.netBoxName = getDefaultCreateValue(
                    item.vendor,
                    _val,
                    item.vendorOptions,
                    [],
                    false
                );
            } else if (item.netBoxDeviceRole) {
                item.netBoxName = getDefaultCreateValue(
                    item.vendor,
                    item.deviceType,
                    item.vendorOptions,
                    item.deviceTypeOptions
                );
            } else if (item.netBoxDeviceManufaturer) {
                item.netBoxName = getDefaultCreateValue(item.vendor, undefined, item.vendorOptions);
            }
            item.isUnavailable = !_val;
            if (item.isUnavailable) {
                item.regex = !_val;
            }
        }
    }

    getSku(data) {
        return this.getFirstAvailableValue(data, "allGluSkus");
    }
    getPlatform(data) {
        return this.getFirstAvailableValue(data, "allGluPlatforms");
    }
    getFirstAvailableValueForVendor(vendor, collection) {
        const vendorItems = collection[vendor] || [];
        const firstAvailable = vendorItems[0];
        return firstAvailable ? firstAvailable : null;
    }
    getFirstAvailableValue(data, collectionKey) {
        const collection = _.get(data, collectionKey, []);
        const vendor = data.vendor;
        return this.getFirstAvailableValueForVendor(vendor, collection);
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: true,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }

    show() {}
    hide() {}
}

module.exports = VendorEditor;
